import { styled } from "@linaria/react";

import { withTheme } from "../theme/GalaxyTheme";
import type { PropsWithTheme } from "../theme/types";

export interface AvatarShimmerProps {
  size?: number;
}

export const StyledAvatarShimmer = withTheme(styled.div<
  PropsWithTheme<{
    $size?: number;
  }>
>`
  background: ${({ theme }) => theme.color.border.primary};
  background-size: 200% 100%;
  animation:
    shimmer 2.5s infinite,
    pulse 2.5s cubic-bezier(0.4, 0, 0.6, 1) infinite;
  height: ${({ $size }) => $size ?? 16}px;
  width: ${({ $size }) => $size ?? 16}px;
  border-radius: 4px;

  @keyframes shimmer {
    0% {
      background-position: -250% 0;
    }
    100% {
      background-position: 150% 0;
    }
  }

  @keyframes pulse {
    0%,
    100% {
      opacity: 0.75;
    }
    50% {
      opacity: 0.25;
    }
  }
`);

const AvatarShimmer = ({ size }: AvatarShimmerProps) => {
  return <StyledAvatarShimmer $size={size} />;
};

export default AvatarShimmer;
